/* _customled-cart-drawer-guard.js — Custom LED owned  [M1.21]
 *
 * Fixes a buy-path integrity race found in the publish-readiness audit (A4-D2):
 * the header mini-cart/drawer renders its own <form action="/cart"> containing
 * one hidden/numeric input per line item named updates[<line>]. All real qty
 * edits happen via AJAX (/cart/change.js etc.), so those inputs go STALE the
 * moment the cart changes anywhere else (cart page steppers, accessory adds).
 * Submitting the drawer form (its checkout button) then POSTs the stale
 * quantities and SILENTLY REWRITES the server cart at checkout handoff —
 * reproduced: checkout opened with 4 items while the server held 5 moments
 * earlier.
 *
 * Fix: capture-phase submit guard. When a cart form INSIDE the mini-cart
 * submits, disable its updates[] inputs so the POST carries no quantity
 * rewrites — the server cart (kept correct by the AJAX flows) is the single
 * source of truth. The drawer's own visible qty steppers are unaffected
 * (they use AJAX, not this form post). No-JS users never run this guard, but
 * they also can't open the JS-driven drawer, so nothing is lost.
 *
 * Owned, zero vendor edits. Loaded globally from _customled-stylesheets.liquid
 * (the drawer exists in the header on every page).
 */
(function () {
  "use strict";
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute("action") || "";
    // match /cart and locale-prefixed variants (/fr/cart, /es/cart), not /cart/add
    if (!/\/cart\/?$/.test(action)) return;
    if (!form.closest("mini-cart, header-mini-cart-dropdown-modal, .mini-cart-wrap")) return;
    form.querySelectorAll('input[name^="updates["]').forEach(function (input) {
      input.disabled = true; // disabled inputs are excluded from the POST
    });
  }, true);
})();
